export const catalogSorter = {
  title: "Smart catalog organizer",
  tabs: {
    manual: "Manual",
    rules: "Rules",
    ai: "AI",
  },
  info: "Drag and drop to sort your products as you prefer. The order will be reflected in your store.",
  updateDisclaimer:
    "The order updates automatically. Last run: {{hour}}",
  preview: "Preview",
  apply: "Apply",
  applying: "Applying...",
  saveSuccess: "Catalog order updated successfully",
  saveError: "Could not update the catalog order",
  improveWithAi: "Improve my catalog order with AI",
  aiDisableHint: "To turn off AI, apply a Manual or Rules order.",
  rules: {
    countVisits: "Most visited",
    createdAt: "Most recent",
    totalOrders: "Best sellers",
    price: "Price",
  },
  empty: {
    title: "You don't have products yet",
    message: "Create your first product to organize your catalog.",
    button: "Create product",
  },
  aiModal: {
    title: "AI sorting",
    message:
      "Artificial intelligence will organize your catalog based on your customers' behavior. The order may take a few minutes to appear.",
  },
  acquire: {
    title: "Activate the smart organizer",
    description:
      "Sort your catalog manually, by rules, or with artificial intelligence.",
    cta: "Get add-on",
  },
};
